import { Lock } from "lucide-react";

interface LockedIconProps {
  className?: string;
  tooltipText?: string;
}

export default function LockedIcon({
  className = "w-4 h-4",
  tooltipText = "This item is locked and cannot be modified",
}: LockedIconProps) {
  return (
    <div title={tooltipText}>
      <Lock className={`text-gray-500 ${className}`} />
    </div>
  );
}
